module.exports = __webpack_public_path__ + "media/images/icon-benefits-productivity-84fc106b27c7de804f11c8dd5f95abf3.png";